__turbopack_context__.v({
  "isHighlightSection": "TileSection-module-scss-module__FPtnsG__isHighlightSection",
  "section": "TileSection-module-scss-module__FPtnsG__section",
});
